module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canvasCurrentView === 'fluxogram'),
      expression: "canvasCurrentView === 'fluxogram'"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "button_close",
    on: {
      "click": function($event) {
        return _vm.canvasChangeView('steps')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" " + _vm._s(_vm.$t('general.actions.close')))]), _vm._v(" "), _c('div', {
    staticClass: "flow_button flow_button__zoom"
  }, [_c('a', {
    staticClass: "flow_button__zoom-btn",
    on: {
      "click": function($event) {
        return _vm.fluxogramZoomIn()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search-plus"
  })]), _vm._v(" "), _c('a', {
    staticClass: "flow_button__zoom-btn",
    on: {
      "click": function($event) {
        return _vm.fluxogramZoomOut()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search-minus"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "klickbox-fluxogram-holder"
  }, [_c('div', {
    staticClass: "klickbox-fluxogram-container"
  })])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-f1502eb8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/fluxogram/Main.vue
 ** module id = 923
 ** module chunks = 1
 **/